import { FC } from "react";
import { _ } from "../../utils/helpers";
import { CardElement } from "@stripe/react-stripe-js";

interface PaymentDetailsProps {
    setStripeComplete: React.Dispatch<React.SetStateAction<boolean>>
} 

export const PaymentDetails: FC<PaymentDetailsProps> = ({setStripeComplete}) => {

    return (
        <fieldset id="payment-details" className="py-8 px-7 r3 mb-8 mt-0">
            <legend className="text s20-600 mb-7">{_('5pi_enter__')}</legend>
            <div className="compound-input">
                <CardElement 
                    options={{hidePostalCode: true}}
                    onChange={event => setStripeComplete(event.complete)}
                />
            </div>
        </fieldset>
    ) 
}
